import {AsyncPipe} from '@angular/common';
import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import {FormsModule} from '@angular/forms';
import {ELoginStatus} from '@app/auth-config/models/auth-state.model';
import {AuthConfigService} from '@app/auth-config/services/auth-config.service';
import {selectTokenStatus} from '@app/auth-config/state/auth.selector';
import {ILanguage} from '@app/shared/models/language.model';
import {getLanguages, setPreferredLanguage} from '@app/shared/state/language/language.action';
import {selectActiveLanguages, selectSelectedLanguage} from '@app/shared/state/language/language.selector';
import {environment} from '@environments/environment';
import {Store} from '@ngrx/store';
import {TranslateService} from '@ngx-translate/core';
import {SelectModule} from 'primeng/select';
import {Observable, Subject, takeUntil, tap} from 'rxjs';

@Component({
  selector: 'app-language-selector',
  imports: [FormsModule, SelectModule, AsyncPipe],
  templateUrl: './language-selector.component.html',
})
export class LanguageSelectorComponent implements OnInit, OnDestroy {
  private readonly store = inject(Store);
  private readonly authConfigService = inject(AuthConfigService);
  private readonly translateService = inject(TranslateService);

  private readonly unsubscribe$ = new Subject<void>();
  activeLanguages$: Observable<ILanguage[]>;
  selectedLanguage: ILanguage | undefined;
  constructor() {
    this.activeLanguages$ = this.store.select(selectActiveLanguages);
  }

  ngOnInit() {
    this.getLanguages();
    this.listenToSelectedLanguage();
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  onChangeLanguage(): void {
    const currentLanguage = this.selectedLanguage?.id.toString() ?? environment.defaultLanguage;
    this.translateService.use(currentLanguage);
    this.store.dispatch(setPreferredLanguage({languageId: currentLanguage}));
  }

  getLanguages(): void {
    this.store
      .select(selectTokenStatus)
      .pipe(
        takeUntil(this.unsubscribe$),
        tap(state => {
          if (state == ELoginStatus.Authorized || this.authConfigService.isTokenValid()) {
            this.store.dispatch(getLanguages());
          }
        })
      )
      .subscribe();
  }

  private listenToSelectedLanguage(): void {
    this.store
      .select(selectSelectedLanguage)
      .pipe(
        takeUntil(this.unsubscribe$),
        tap(state => {
          if (state) {
            this.selectedLanguage = state;
            this.translateService.use(state.id.toString());
          }
        })
      )
      .subscribe();
  }
}
